import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import shift from "../images/shift.png";
import two from "../images/2.png";

const Page3 = (rond) => {
  const navigate = useNavigate();
  const location = useLocation();
  // const allResults = location.state.allResults;
  // const round = location.state.round || 0;

  const allResults = location.state.allResults;
  const { round } = rond;

  const data = [
    { round: "Round", shifts: "Shifts" },
    { round: 1, shifts: 1 },
    { round: 2, shifts: 1 },
    { round: 3, shifts: 2 },
    { round: 4, shifts: 2 },
    { round: 5, shifts: 2 },
    { round: 6, shifts: 2 },
    { round: 7, shifts: 2 },
    { round: 8, shifts: 2 },
    { round: 9, shifts: 1 },
    { round: 10, shifts: 2 },
    { round: 11, shifts: 2 },
    { round: 12, shifts: 2 },
    { round: 13, shifts: 2 },
    { round: 14, shifts: 2 },
    { round: 15, shifts: 2 },
    { round: 16, shifts: 1 },
  ];

  const roundNo = round + 1;
  return (
    <>
      <div className="text-xl text-center pb-24 pt-5">
        Round {round + 1} Key Generation
      </div>
      <div>
        <div className="flex flex-row pb-40">
          {data.map((item) => (
            <div
              key={item.round}
              className={`p-2 ${item.round === roundNo ? "bg-blue-200" : ""}`}
            >
              <div className="text-center"> {item.round}</div>
              <div className="text-center">{item.shifts}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex items-center space-x-4 m-10">
        <div className="flex flex-col space-y-4">
          <p>Left 28 bits before shift</p>

          <div className="bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus">
            <svg
              width="28"
              height="30"
              viewBox="0 0 12 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 14V14C3.44624 9.65575 9.64447 9.6266 11 14V14"
                stroke="black"
              />
              <line
                x1="0.474342"
                y1="11.8419"
                x2="1.47434"
                y2="14.8419"
                stroke="black"
              />
              <line
                x1="4.27735"
                y1="13.416"
                x2="1.27735"
                y2="15.416"
                stroke="black"
              />
            </svg>

            {allResults[round][0][0].slice(0, 7)}
            <br></br>
            {allResults[round][0][0].slice(7, 14)}
            <br></br>
            {allResults[round][0][0].slice(14, 21)}
            <br></br>
            {allResults[round][0][0].slice(21, 28)}
            <br></br>
          </div>
          <p>Right 28 bits before shift</p>
          <div className="bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus">
            <svg
              width="28"
              height="30"
              viewBox="0 0 12 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2 14V14C3.44624 9.65575 9.64447 9.6266 11 14V14"
                stroke="black"
              />
              <line
                x1="0.474342"
                y1="11.8419"
                x2="1.47434"
                y2="14.8419"
                stroke="black"
              />
              <line
                x1="4.27735"
                y1="13.416"
                x2="1.27735"
                y2="15.416"
                stroke="black"
              />
            </svg>
            {allResults[round][0][1].slice(0, 7)}
            <br></br>
            {allResults[round][0][1].slice(7, 14)}
            <br></br>
            {allResults[round][0][1].slice(14, 21)}
            <br></br>
            {allResults[round][0][1].slice(21, 28)}
            <br></br>
          </div>
        </div>

        <svg
          width="300"
          height="38"
          viewBox="0 0 573 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M571.771 20.7678C572.748 19.7915 572.748 18.2085 571.771 17.2322L555.861 1.32233C554.885 0.34602 553.302 0.34602 552.326 1.32233C551.349 2.29864 551.349 3.88155 552.326 4.85786L566.468 19L552.326 33.1421C551.349 34.1184 551.349 35.7014 552.326 36.6777C553.302 37.654 554.885 37.654 555.861 36.6777L571.771 20.7678ZM0 21.5H570.003V16.5H0V21.5Z"
            fill="black"
          />
        </svg>

        <div className="flex flex-col space-y-4">
          <p>Left 28 bits after shift</p>
          <div className="bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus">
            {allResults[round][1][0][0]}
            <br></br>
            {allResults[round][1][0][1]}
            <br></br>
            {allResults[round][1][0][2]}
            <br></br>
            {allResults[round][1][0][3]}
            <br></br>
          </div>
          <p>Right 28 bits after shift</p>
          <div className="bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out tracking-widest-plus">
            {allResults[round][1][1][0]}
            <br></br>
            {allResults[round][1][1][1]}
            <br></br>
            {allResults[round][1][1][2]}
            <br></br>
            {allResults[round][1][1][3]}
            <br></br>
          </div>
        </div>
        <img src={two} width="300" height="300" className="pl-10" />
      </div>
    </>
  );
};

export default Page3;
